module.exports = __webpack_public_path__ + "files/40dc52aa8e17ae5fec9ee893c0273606.png";